import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import BasePoints from '../../../assets/base-points';
import CreditCard from '../../../assets/hyatt-credit-card';
import PointsBonus from '../../../assets/points-bonus';
import PayWithPoints from '../../../assets/pay-with-points';

const Container = styled.div`
  margin-bottom: 16px;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ListItem = styled.li`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 8px;
`;

const StyledTrans = styled(Trans)`
  font-size: 14px;
  line-height: 1.4;
  flex: 1;
`;

interface HyattExperienceBenefitsProps {
  payEligible?: boolean;
  earnEligible?: boolean;
}

const HyattExperienceBenefits = ({
  payEligible,
  earnEligible,
}: HyattExperienceBenefitsProps) => {
  return (
    <Container>
      <List>
        <ListItem>
          <BasePoints />
          <StyledTrans
            i18nKey={
              earnEligible && !payEligible
                ? 'experienceBenefits.benefits.basePointsEarn'
                : 'experienceBenefits.benefits.basePoints'
            }
            components={{ strong: <strong /> }}
          />
        </ListItem>
        <ListItem>
          <CreditCard />
          <StyledTrans
            i18nKey="experienceBenefits.benefits.additionalBonusPoints"
            components={{
              strong: <strong style={{ whiteSpace: 'nowrap' }} />,
            }}
          />
        </ListItem>
        <ListItem>
          <PointsBonus />
          <StyledTrans
            i18nKey="experienceBenefits.benefits.additionalBonusPointsTier"
            components={{ strong: <strong /> }}
          />
        </ListItem>
        {payEligible && (
          <ListItem>
            <PayWithPoints />
            <StyledTrans
              i18nKey="experienceBenefits.benefits.payWithPoints"
              components={{ strong: <strong /> }}
            />
          </ListItem>
        )}
      </List>
    </Container>
  );
};

export default HyattExperienceBenefits;
